import { render } from "./AddCustomerPage.vue?vue&type=template&id=8d6211fa&scoped=true"
import script from "./AddCustomerPage.vue?vue&type=script&lang=js"
export * from "./AddCustomerPage.vue?vue&type=script&lang=js"

import "./AddCustomerPage.vue?vue&type=style&index=0&id=8d6211fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d6211fa"]])

export default __exports__